import { useNavigate } from "react-router-dom";

export default function Button({
    id = "",
    textButton = "",
    type,
    ariaHidden,
    urlButton = "",
    onClick = () => { },
    target = "_self",
    disabled = false,
    className = "",
}) {
    const navigate = useNavigate();

    function handleClick(e) {
        if (disabled) return;
        if (urlButton) {
            if (target === "_blank") {
                window.open(urlButton);
            } else {
                navigate(urlButton);
            }
        }
        onClick(e);
    }
  return (
    <button
        id={id}
        type={type}
        className={className}
        aria-hidden={ariaHidden}
        onClick={handleClick}
        disabled={disabled}
    >
      {textButton}
    </button>
  )
}
